import { ISnackbarRefresh } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_ID_REFRESH } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { getMessages } from 'app/store/constants';
import { SnackbarVariant } from '../../store/types';

export const snackbarRefreshDefault = (
    options: ISnackbarRefresh
) => {
    return (dispatch: Dispatch) => {
        const buttons = [
            {
                onClick: () => {
                    dispatch(getDefaultActionEvent(SNACKBAR_ID_REFRESH, options.actionApply));
                },
                isPrimary: true,
                text: getMessages().getText('snackbar.refresh.button'),
            },
        ];
        dispatch(addUpdateSnackbarWithBubble({
            id: SNACKBAR_ID_REFRESH,
            buttons,
            title: getMessages().getText('snackbar.refresh.title'),
            icon: 'info',
            text: getMessages().getText('snackbar.refresh.text'),
            variant: SnackbarVariant.REFRESH,
            onTimer: () => {
                dispatch(getDefaultActionEvent(SNACKBAR_ID_REFRESH, options.actionApply));
            }
        }));
    }
};
